import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=31a39ee9&scoped=true"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=31a39ee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a39ee9",
  null
  
)

export default component.exports